import { getPhrase, Say } from "../../../languages";

export function ThankYouFooter() {
  return (
    <div className="ThankYouFooter thankyou-footer">
      <p>
        <Say phrase="chosen.thank_you.questions" />{" "}
        <a
          href={`tel:+1${getPhrase("chosen.thank_you.phone_number").replace(/[^\d]*/gi, "")}`}
          className="phone-help">
          <Say phrase="chosen.thank_you.phone_number" />
        </a>
      </p>
    </div>
  );
}

export default ThankYouFooter;
